import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "Practice Areas", href: "/practice-areas" },
  { label: "About", href: "/about" },
  { label: "Results", href: "/results" },
  { label: "Locations", href: "/locations/philadelphia" },
  { label: "Contact", href: "/contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled ? "bg-[#0A1628] shadow-lg" : "bg-transparent"
        }`}
      >
        <nav className="flex items-center justify-between px-6 lg:px-12 h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center cursor-pointer">
            <img
              src="https://storage.readdy-site.link/project_files/99cc58db-129a-4686-a4b4-ed4119f2d499/cece8882-bf3a-4abf-a433-1e2e0b2a4be6_logo-gosfield-white.png?v=7205bb5119f4d5eb9bba279978db363a"
              alt="Alice G. Gosfield &amp; Associates, P.C."
              className="h-14 w-auto object-contain"
            />
          </Link>

          {/* Desktop Nav */}
          <ul className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <li key={link.href}>
                <Link
                  to={link.href}
                  className={`text-sm font-inter font-medium tracking-wide transition-colors duration-200 whitespace-nowrap cursor-pointer relative group ${
                    location.pathname === link.href ? "text-[#C9A961]" : "text-slate-300 hover:text-white"
                  }`}
                >
                  {link.label}
                  <span className="absolute -bottom-1 left-0 h-px w-0 bg-[#C9A961] transition-all duration-300 group-hover:w-full" />
                </Link>
              </li>
            ))}
          </ul>

          {/* Desktop CTAs */}
          <div className="hidden lg:flex items-center gap-3">
            <a
              href="tel:+12157352384"
              className="flex items-center gap-2 text-sm font-inter font-medium text-slate-300 hover:text-[#C9A961] transition-colors whitespace-nowrap cursor-pointer"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-phone-line text-[#C9A961]" />
              </span>
              (215) 735-2384
            </a>
            <Link
              to="/contact"
              className="bg-[#C9A961] hover:bg-[#b8954f] text-[#0A1628] text-sm font-inter font-semibold px-5 py-2.5 rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Free Consultation
            </Link>
          </div>

          {/* Mobile hamburger */}
          <button
            className="lg:hidden w-10 h-10 flex items-center justify-center text-white cursor-pointer"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <i className={`ri-${menuOpen ? "close" : "menu"}-line text-2xl`} />
          </button>
        </nav>
      </header>

      {/* Mobile Menu Overlay */}
      {menuOpen && (
        <div className="fixed inset-0 z-40 bg-[#0A1628] flex flex-col pt-24 px-8 lg:hidden">
          <ul className="flex flex-col gap-6 mb-8">
            {navLinks.map((link) => (
              <li key={link.href}>
                <Link
                  to={link.href}
                  className="text-2xl font-playfair text-white hover:text-[#C9A961] transition-colors cursor-pointer"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
          <div className="flex flex-col gap-4 mt-4">
            <a
              href="tel:+12157352384"
              className="flex items-center gap-2 text-[#C9A961] text-lg font-inter whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line" /> (215) 735-2384
            </a>
            <Link
              to="/contact"
              className="bg-[#C9A961] text-[#0A1628] text-center py-3 rounded-md font-semibold font-inter cursor-pointer whitespace-nowrap"
            >
              Free Consultation
            </Link>
          </div>
        </div>
      )}

      {/* Mobile sticky bottom bar */}
      <div className="fixed bottom-0 left-0 right-0 z-50 lg:hidden flex border-t border-slate-700 bg-[#0A1628]">
        <a
          href="tel:+12157352384"
          className="flex-1 flex items-center justify-center gap-2 py-3.5 text-sm font-inter font-medium text-white whitespace-nowrap cursor-pointer border-r border-slate-700"
        >
          <i className="ri-phone-line text-[#C9A961]" /> Call Now
        </a>
        <Link
          to="/contact"
          className="flex-1 flex items-center justify-center gap-2 py-3.5 text-sm font-inter font-semibold bg-[#C9A961] text-[#0A1628] whitespace-nowrap cursor-pointer"
        >
          <i className="ri-calendar-line" /> Consultation
        </Link>
      </div>
    </>
  );
}
